module.exports = __webpack_public_path__ + "img/yy4.de74c970.png";